<div class="container-margin">
  <div *ngIf="!isLoading">
    <h1 style="color: #0074a7" class="page-title" translate>
      components.cookiePolicy.TÉRMINOS Y CONDICIONES
    </h1>
    <span [innerHTML]="transform(terms)" style="word-wrap: break-word"></span>
  </div>
  <div
    *ngIf="isLoading"
    class="text-center col-12"
    style="padding: 20px 0 30px 0"
  >
    <app-spinner></app-spinner>
  </div>
</div>
